<div class="toolbarSection push-right" *ngIf="!hide">
  <div class="toolbarDivider"></div>
  <acl-ngx-dropdown-button [menuItems]="filterSetup" [variant]="buttonProps.variant" [icon]="buttonProps.icon">
  </acl-ngx-dropdown-button>
</div>